// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2afEh","inputWrap":"styles_inputWrap__206q1","input":"styles_input__3Vgse"};